import { authService } from 'services/auth'
import getEnvFromLocation from 'utils/getEnvFromLocation'

export type TerritoryChartTypes = 'trending' | 'mostEngagedCreators' | 'mostEngagedPosts'

type SoAEmbedInput = {
  workspaceId: string
  categoryId: string
}

type TerritoryEmbedInput = {
  workspaceId: string
  territoryId: string
}

type CreateEmbedPayload = {
  chartType: 'shareOfAttention' | TerritoryChartTypes
  filters: SoAEmbedInput | TerritoryEmbedInput
  dataType?: TerritoryChartTypes
}

type CreateEmbedResponseData = {
  url: string
}

export class ComponentsService {
  private baseUrl: string

  constructor() {
    this.baseUrl = this.getBaseURLByEnvironment()
  }

  // TODO: Implement HttpAdapter and inject it here to use it instead of fetch directly
  // constructor(private http: Http) { }

  async generateEmbedURL(payload: CreateEmbedPayload): Promise<string> {
    const accessToken = await authService.getAccessToken()
    if (!accessToken) throw new Error('Missing access token')

    const requestOptions: RequestInit = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: accessToken,
      },
      body: JSON.stringify({
        chartType: payload.chartType,
        ...(payload.dataType && { dataType: payload.dataType }),
        filters: payload.filters,
      }),
    }

    const getRequestURL = () => {
      if (payload.chartType === 'shareOfAttention') {
        return `${this.baseUrl}/api/v1/create/brand`
      }
      return `${this.baseUrl}/api/v1/create/territory`
    }

    const url = getRequestURL()

    const response = await fetch(url, requestOptions)
    const data: CreateEmbedResponseData = await response.json()

    return data?.url
  }

  getBaseURLByEnvironment() {
    const environment = getEnvFromLocation()

    if (environment === 'development') {
      return 'https://embed.dev.insights.winnin.com'
    }

    if (environment === 'production') {
      return 'https://embed.insights.winnin.com'
    }
    if (environment === 'staging') {
      return 'https://embed-staging.insights.winnin.com'
    }

    return 'https://embed.dev.insights.winnin.com'
  }
}
